// @flow
import * as React from 'react';

import DisambiguationItem from '.';

type Props = {
  item: Object,
  selected?: boolean,
  onItemClick?: Function | boolean,
};

export class DisambiguationItemContainer extends React.Component<Props> {
  static defaultProps: {
    onItemClick: false,
    selected: false,
  };

  constructor(props: Props): void {
    super(props);

    // $FlowFixMe
    this.handleItemClick = this.handleItemClick.bind(this);
  }

  handleItemClick(e: SyntheticEvent<HTMLLinkElement>): void {
    const { item, onItemClick } = this.props;

    if (typeof onItemClick === 'function') {
      onItemClick(item);
    }

    e.preventDefault();
  }

  render(): React.Node {
    return <DisambiguationItem {...this.props} onItemClick={this.handleItemClick} />;
  }
}

DisambiguationItemContainer.defaultProps = {
  onItemClick: false,
  selected: false,
};

export default DisambiguationItemContainer;



// WEBPACK FOOTER //
// ./app/common/Lists/DisambiguationList/item/container.js